var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ElButton',{attrs:{"icon":"el-icon-setting"},on:{"click":_vm.showHiddenAppsModal}},[_vm._v("\n  "+_vm._s(_vm.$t('APPS.HIDDEN_APPS.TITLE'))+"\n  "),_c('Hint',{attrs:{"message":_vm.$t('HINTS.APPS.HIDDEN_APPS')}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }